import React from "react";
import { useTranslation } from "react-i18next";

const LocalizedErrorFallback = ({ onReload }) => {
  const { t } = useTranslation();
  return (
    <div
      style={{
        padding: 40,
        textAlign: "center",
        fontFamily: '"Montserratarm", sans-serif',
      }}
    >
      <h2>{t("common.errorTitle")}</h2>
      <p>{t("common.errorDescription")}</p>
      <button
        type="button"
        onClick={onReload}
        style={{ padding: "8px 20px", cursor: "pointer" }}
      >
        {t("common.reload")}
      </button>
    </div>
  );
};

// WEB-05 / UX-11: a root error boundary so a single component render throw (a bad
// payload, a 3D-canvas error, etc.) can't white-screen the entire SPA. Wrap the
// app root with this; heavier surfaces (editor, 3D, chat) can add their own.
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    // Log for diagnostics; a future Sentry hook can capture here.
    console.error("Unhandled render error:", error, info);
  }

  handleReload = () => {
    this.setState({ hasError: false });
    window.location.assign("/");
  };

  render() {
    if (this.state.hasError) {
      return (
        this.props.fallback || (
          <LocalizedErrorFallback onReload={this.handleReload} />
        )
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
